export default "__VITE_ASSET__BXVX8t$7__"